
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import  { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import RenderPopup from "vagaro-website-rendering/src/components/ComponentRenders/RenderPopup";






export default class WBPopup extends WBComponent {

    


    constructor(){
        super();
        this.typename =wBComponentTypeNames.popup;
        this.displayName = "Pop-up";
        this.dropList = [];
        this.primaryEditAttributes= [
            "popup-enabled",
            "pop-title",
            "pop-description",
            "pop-layout",
            "pop-image",
            "pop-goal",
            "pop-main-btn-link",
            "pop-main-btn-txt",
            "pop-sec-btn-link",
            "pop-sec-btn-txt",
            "pop-main-btn-link",
            "show-popup",
            "pop-timing",
            "pop-frequency",
            "pop-title-text",
            "pop-text-color",
            "pop-desc-text",
            "pop-desc-color",
            "pop-main-btn",
            "pop-second-btn",
            "pop-bg-color",
            "pop-up-email-or-phone",
            "pop-up-gender"
        ];
        this.editList =  ["group-id","pop-up-valid",...this.primaryEditAttributes,componentAttributeTypes.multiLocation];

        this.contentEditable = false;
   
    
        
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        const popupEnabled = new AttributeDefinition("popup-enabled","","",AttributeInputType.ButtonField,[{label:"Enable",value:"enabled"},{label:"Disable",value:""}]);
        
        const popupTitle = new AttributeDefinition("pop-title","Title","",AttributeInputType.InputFiled);
        popupTitle.placeHolder = "Type Title";

        const popupDescription = new AttributeDefinition("pop-description","Description","",AttributeInputType.EmojiField);
        popupDescription.placeHolder = "Type Message";

        const popupDiscalimer = new AttributeDefinition("pop-disclaimer","Disclaimer","",AttributeInputType.EmojiField);
        popupDiscalimer.placeHolder = "By submitting this form, you consent to receive marketing communications from us. We value your privacy and won't share your email with third parties. You can unsubscribe at any time.";
        const popupLayout = new AttributeDefinition("pop-layout","Layout","",AttributeInputType.SelectField,[{label:"Vertical",value:""},{label:"Horizontal",value:"horizontal"}]);
        const pupupImage = new AttributeDefinition("pop-image","Image","",AttributeInputType.ImageField);
        const popupGoal = new AttributeDefinition("pop-goal","Pop-Up Goal","",AttributeInputType.ButtonField,[{label:"Button Click",value:""},{label:"Subscribe",value:"subscribe"}]);

        const mainBtnLink = new AttributeDefinition("pop-main-btn-link","Main Button Link","",AttributeInputType.LinkField);
        const mainBtnTxt = new AttributeDefinition("pop-main-btn-txt","Main Button Text","",AttributeInputType.InputFiled);
        mainBtnTxt.placeHolder = "Button Text";

        const secBtnLink = new AttributeDefinition("pop-sec-btn-link","Secondary Button Link","",AttributeInputType.LinkField);
        const secBtnTxt = new AttributeDefinition("pop-sec-btn-txt","Secondary Button Text","",AttributeInputType.InputFiled);
        const completionLink = new AttributeDefinition("pop-completion-link","Completion Link","",AttributeInputType.LinkField);
        secBtnTxt.placeHolder = "Button Text";

  
        completionLink.description = "Send customers to this link after they submit."

        const showPopUp = new AttributeDefinition("show-popup","Show Pop-Up","",AttributeInputType.ButtonField,[{label:"Any First Page",value:""},{label:"Certain Pages",value:"certain"}]);
        const pagesToShowOn = new AttributeDefinition("pop-pages-to-show-on","Pages to Show On","",AttributeInputType.MultiPageSelect);
        // const shoOnPages = new AttributeDefinition("show-on-pages","Show On Pages","",AttributeInputType.sele);
        const popupTiming = new AttributeDefinition("pop-timing","Timing","",AttributeInputType.SelectField,[{label:"Immediately",value:""},{label:"After 5 seconds",value:"5"},{label:"After 10 seconds",value:"10"},{label:"After 30 seconds",value:"30"}]);
        const popupFrequency = new AttributeDefinition("pop-frequency","Frequency","",AttributeInputType.SelectField,[{label:"Next Day",value:""},{label:"1 Week",value:"7"},{label:"2 Weeks",value:"14"},{label:"30 Days",value:"30"},{label:"Never",value:"365"}]);

        const titleText = new AttributeDefinition("pop-title-text","Title Text","",AttributeInputType.SelectField,[{label:"Heading 1",value:"h1"},{label:"Heading 2",value:""},{label:"Heading 3",value:"h-3"},{label:"Heading 4",value:"h-4"}]);
        const textColor = new AttributeDefinition("pop-text-color","Text Color","",AttributeInputType.ColorField);

        const descText = new AttributeDefinition("pop-desc-text","Description Text","",AttributeInputType.SelectField,[{label:"Paragraph 1",value:"vp-1"},{label:"Paragraph 2",value:""},{label:"Paragraph 3",value:"vp-3"}]);
        const descColor = new AttributeDefinition("pop-desc-color","Description Color","",AttributeInputType.ColorField);

        const mainBtn = new AttributeDefinition("pop-main-btn","Main Button","",AttributeInputType.SelectField,[{label:"Primary",value:""},{label:"Secondary",value:"secondary"},{label:"Tertiary",value:"tertiary"}]);
        const secondaryBtn = new AttributeDefinition("pop-second-btn","Secondary Button","",AttributeInputType.SelectField,[{label:"Primary",value:"primary"},{label:"Secondary",value:""},{label:"Tertiary",value:"tertiary"}]);
        const bgColor = new AttributeDefinition("pop-bg-color","Background Color","",AttributeInputType.ColorField);
        const dontShowAfterSub = new AttributeDefinition("pop-show-after-sub","Don't Show After Subscribing","",AttributeInputType.SingleCheckField);
        const emailOrPhonSelection = new AttributeDefinition("pop-up-email-or-phone","Email or Phone","",AttributeInputType.RadioField,[{label:"Require Email",value:""},{label:"Require Email & Phone",value:"email-phone"}]);
        const askGender = new AttributeDefinition("pop-up-gender","Ask for Gender","",AttributeInputType.SingleCheckField);
        return [popupDiscalimer,popupEnabled,popupTitle,completionLink,popupDescription,pagesToShowOn,popupLayout,pupupImage,popupGoal,mainBtnLink,mainBtnTxt,secBtnLink,secBtnTxt,dontShowAfterSub,showPopUp,popupTiming,popupFrequency,titleText,textColor,descText,descColor,mainBtn,secondaryBtn,bgColor,emailOrPhonSelection,askGender];
    
    }

    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps)
     {

        return (


            <RenderPopup userContext={userContext} component={component} />
        )

    }

}